<template>
    <div>
        <div class="address" v-if="false">
            <input type="text" v-model="address" placeholder="输入城市名称搜索" />
        </div>
        <div class="searchList">
            <ul>
                <li v-for="(item,index) in searchList" :key="index" @click="onClick(item.code)">
                    {{item.name}} - <span>{{item.pro}}</span>
                </li>
            </ul>
        </div>
        <div class="city">
            <label>主要城市</label>
            <div>
                <div v-for="item in mainCityList" :key="item.code">
                    <span @click="onClick(item.code,item.name)">{{item.name}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            address: "",
            list: [
                // { name: "石家庄", pro: "河北", code: "23112" },
            ],
            mainCityList: [
                // { name: "北京", code: "23112" },
            ]
        };
    },
    mounted(){
        this.loadCity();
    },
    computed: {
        searchList() {
            if (this.address.trim().length == 0) return [];
            return this.list.filter(item => item.name.includes(this.address));
        }
    },
    methods: {
        onClick(code,name) {
            this.$router.push(`/city/weather/${code}/${name}`);
        },
        loadCity(){
            this.ajax('wxInterface/areaQuery',{},data => {
                this.mainCityList = data;
            });
        },
    }
};
</script>

<style lang="less" scoped>
div {
    color: white;
}
.address {
    padding: 20px;
    box-sizing: border-box;

    > input {
        width: 100%;
        border: none;
        border-radius: 20px;
        outline: none;
        height: 35px;
        padding: 0 20px;
        box-sizing: border-box;
        background-color: rgba(0, 0, 0, 0.2);
        color: white;
    }
}

.searchList {
    ul {
        margin: 0;
        padding: 0;
        li {
            display: block;
            padding: 10px 20px;
            background-color: rgba(0, 0, 0, 0.2);
            border-bottom: 1px solid rgba(255, 255, 255, 0.3);

            > span {
                color: #cddc39;
            }
        }
    }
}

.city {
    > label {
        display: block;
        padding: 20px;
        font-size: larger;
    }

    > div {
        padding: 0 10px;
        box-sizing: border-box;

        > div {
            float: left;
            width: 25%;
            padding: 0 5px;
            margin-bottom: 10px;
            text-align: center;
            box-sizing: border-box;

            > span {
                display: block;
                padding: 5px 0;
                background-color: rgba(0, 0, 0, 0.2);
                border-radius: 5px;
                overflow: hidden;
                white-space: nowrap;
            }
        }

        &::after {
            content: "";
            display: block;
            clear: both;
        }
    }
}
</style>